export enum UserSettingKey {
  ENABLE_PUSH_NOTIFICATIONS = 'enablePushNotifications',
  ENABLE_EMAIL_NOTIFICATIONS = 'enableEmailNotifications',
  ENABLE_WHATSAPP_NOTIFICATIONS = 'enableWhatsappNotifications',
}

export interface UserSetting {
  key: UserSettingKey;
  value: string;
}

export interface UpdateUserSettingsPayload {
  settings: UserSetting[];
}

export type NotificationChannelSettings = {
  whatsapp: boolean;
  email: boolean;
  push: boolean;
};

export const defaultNotificationChannelSettings: NotificationChannelSettings = {
  whatsapp: true,
  email: true,
  push: true,
};

export function parseUserSettingBoolean(
  value: string | undefined,
  defaultValue = true,
): boolean {
  if (value === undefined || value === null || value.trim() === '') {
    return defaultValue;
  }

  return value.trim().toLowerCase() === 'true';
}

export function toUserSettingBooleanValue(enabled: boolean): string {
  return enabled ? 'true' : 'false';
}

export function notificationSettingsFromUserSettings(
  settings: UserSetting[],
  defaults: NotificationChannelSettings = defaultNotificationChannelSettings,
): NotificationChannelSettings {
  const byKey = new Map(settings.map(setting => [setting.key, setting.value]));

  return {
    whatsapp: parseUserSettingBoolean(
      byKey.get(UserSettingKey.ENABLE_WHATSAPP_NOTIFICATIONS),
      defaults.whatsapp,
    ),
    email: parseUserSettingBoolean(
      byKey.get(UserSettingKey.ENABLE_EMAIL_NOTIFICATIONS),
      defaults.email,
    ),
    push: parseUserSettingBoolean(
      byKey.get(UserSettingKey.ENABLE_PUSH_NOTIFICATIONS),
      defaults.push,
    ),
  };
}

export function userSettingsFromNotificationSettings(
  settings: NotificationChannelSettings,
): UserSetting[] {
  return [
    {
      key: UserSettingKey.ENABLE_WHATSAPP_NOTIFICATIONS,
      value: toUserSettingBooleanValue(settings.whatsapp),
    },
    {
      key: UserSettingKey.ENABLE_EMAIL_NOTIFICATIONS,
      value: toUserSettingBooleanValue(settings.email),
    },
    {
      key: UserSettingKey.ENABLE_PUSH_NOTIFICATIONS,
      value: toUserSettingBooleanValue(settings.push),
    },
  ];
}
